"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mobxReact = require("mobx-react");
var _react = _interopRequireWildcard(require("react"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _AppUtil = require("../../../../util/AppUtil");
var _HidingBrandingView = _interopRequireDefault(require("../presentation/HidingBrandingView"));
var _class;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
* Container component for hiding branding
*/
let HidingBrandingContainer = (0, _mobxReact.observer)(_class = class HidingBrandingContainer extends _react.Component {
  constructor() {
    super();
    this._uiHandler = _ServiceRegistry.default.getService("UIHandler");
    this._appStore = _ServiceRegistry.default.getService("AppStore");
    this._config = this._appStore.getConfig();
    this._brandingLabelRef = _react.default.createRef();
    this._handleMouseOut = this._handleMouseOut.bind(this);
    this._handleMouseMoveOver = this._handleMouseMoveOver.bind(this);
    this._touchStart = this._touchStart.bind(this);
    this._touchMove = this._touchMove.bind(this);
    this._touchEnd = this._touchEnd.bind(this);
    this._tapOnDevice = this._tapOnDevice.bind(this);
  }
  getDOMElementForEvent() {
    return this._config.isViewSDKPublic ? window.document : (0, _AppUtil.getDOMElement)();
  }
  componentDidMount() {
    this.getDOMElementForEvent().addEventListener("mousemove", this._handleMouseMoveOver);
    this.getDOMElementForEvent().addEventListener("mouseout", this._handleMouseOut);
    if (this._appStore.isOnDevice) {
      this.getDOMElementForEvent().addEventListener("touchstart", this._touchStart);
      this.getDOMElementForEvent().addEventListener("touchmove", this._touchMove);
      this.getDOMElementForEvent().addEventListener("touchend", this._touchEnd);
    }
  }
  componentWillUnmount() {
    this.getDOMElementForEvent().removeEventListener("mousemove", this._handleMouseMoveOver);
    this.getDOMElementForEvent().removeEventListener("mouseout", this._handleMouseOut);
    if (this._appStore.isOnDevice) {
      this.getDOMElementForEvent().removeEventListener("touchstart", this._touchStart);
      this.getDOMElementForEvent().removeEventListener("touchmove", this._touchMove);
      this.getDOMElementForEvent().removeEventListener("touchend", this._touchEnd);
    }
  }
  _touchStart() {
    // Reset any touch move
    this._noTouchMovement = true;
  }
  _touchMove() {
    this._noTouchMovement = false;
  }
  _touchEnd() {
    if (this._noTouchMovement) {
      this._tapOnDevice();
    }
  }
  _tapOnDevice() {
    const height = this._config.isViewSDKPublic ? window.innerHeight : (0, _AppUtil.getDOMElement)().clientHeight;
    const width = this._config.isViewSDKPublic ? window.innerWidth : (0, _AppUtil.getDOMElement)().clientWidth;
    this._uiHandler.showBrandingLabel(height, width);
  }
  _handleMouseOut() {
    if (!this._brandingLabelRef || !this._brandingLabelRef.style) {
      return;
    }
    const height = this._config.isViewSDKPublic ? window.innerHeight : (0, _AppUtil.getDOMElement)().clientHeight;
    const width = this._config.isViewSDKPublic ? window.innerWidth : (0, _AppUtil.getDOMElement)().clientWidth;
    this._uiHandler.fadeBrandingLabel(height, width);
  }
  _handleMouseMoveOver(event) {
    if (!event) {
      return;
    }
    let reactElement = {};
    if (!this._config.isViewSDKPublic) {
      reactElement = (0, _AppUtil.getDOMElement)().getBoundingClientRect();
    }
    const clientY = this._config.isViewSDKPublic ? event.clientY : event.clientY - reactElement.top;
    const clientX = this._config.isViewSDKPublic ? event.clientX : event.clientX - reactElement.left;
    if (this._uiHandler.inHoverRangeOfBrandingLabel(clientY, clientX)) {
      this._uiHandler.showBrandingLabel(clientY, clientX);
    }
  }
  getProps() {
    return {};
  }
  render() {
    if (this._appStore.fileLoaded) {
      const setRef = ref => {
        this._brandingLabelRef = ref;
        this._uiHandler.initialiseBrandingLabelRef(ref);
        this._uiHandler.showBrandingLabel(100, 100);
      };
      return /*#__PURE__*/_react.default.createElement(_HidingBrandingView.default, _extends({
        setRef: setRef
      }, this.getProps()));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
}) || _class;
var _default = exports.default = HidingBrandingContainer;